import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capacitaciones-tipos-index-modulos-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class CapacitacionesTiposIndexModulosEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
